import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import UniversityExportModal from 'components/Modals/ExportModal/UniversityExportModal'
import {
  getUniversitiesSummaryForTable,
  listUniversitiesForTable,
} from 'services/universities'
import { UniversitiesFilterset } from './UniversitiesFilterset'
import { useUniversitiesTableCols } from './universitiesTableColumns'

const sortableFields: string[] = [
  'institution_name',
  'total_students_enrolled',
  'note_count',
  'contact_count',
  'deal_count',
  'address',
  'city',
  'state_abbr',
  'zipcode',
  'domain',
  'dormitory_capacity',
  'meal_plan_provided',
  'total_enrollment',
  'food_management_company',
  'food_management_company_parent',
  'estimated_meals_per_day',
  'carnegie_classification_2021_size_setting_size',
  'carnegie_classification_2021_size_setting_year',
  'carnegie_classification_2021_size_setting_student_composition',
  'sales_stages',
]

export const universitiesTableConfig = defineTargetTableConfig({
  vertical: 'university',
  // University detail link reads `university.institution_id` (see
  // universitiesTableColumns name cell), not `.id`.
  rowConfig: { nestKey: 'university', detailLinkIdField: 'institution_id' },
  filterIdentifier: 'CNU_TABLE',
  savedPresetsIdentifier: 'CNU_TABLE',
  companyTypeSlug: 'education-cu',
  tableTypeSlug: 'education-cu',
  sortableFields,
  preferredGroupOrder: [
    'Target Attributes',
    'Campaigns and Deals',
    'Classification and Enrollment',
    'Dining Services',
  ],
  searchPlaceholder: 'Search universities by name',
  useColumns: useUniversitiesTableCols,
  Filterset: UniversitiesFilterset,
  ExportModal: UniversityExportModal,
  // Standalone openapi-codegen service fns (services/universities) replaced the
  // legacy `api.getUniversitiesList` / `api.getUniversitySummary` hook methods
  // on dev — they're drop-in (same StandardPaginatedResponse/Summary shapes),
  // so the resolver ignores `api` and returns them directly.
  resolveLegacyActions: () => ({
    listAction: listUniversitiesForTable,
    summaryAction: getUniversitiesSummaryForTable,
  }),
})

export function UniversitiesTable(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={universitiesTableConfig} {...props} />
}
